"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfnSplitIntoBatchesOutputDto = void 0;
class SfnSplitIntoBatchesOutputDto {
}
exports.SfnSplitIntoBatchesOutputDto = SfnSplitIntoBatchesOutputDto;
//# sourceMappingURL=SfnSplitIntoBatchesOutputDto.js.map